import { Col, Row, Container, Card, Button } from "react-bootstrap";
import storage from "helpers/storage";

import { DataTable } from "./DataTable";
import { useNavigate } from "react-router-dom";
import { nameBasedProtectedRoutes } from "router/protected";

export const Users = () => {
  const navigate = useNavigate()
  const userInformation: any = storage.getData("user-info");

  const userId = userInformation.id;
  const handleAddView = () =>{
    navigate(nameBasedProtectedRoutes.AddUser.path);
  }
  return (
    <section className="profile-main pt-4 dashboard-content">
      <Container className="">
        <Row>
          <Col md={12} lg={12} className="d-flex justify-content-between align-items-center">
            <h1 className="fs-30 fw-bold mb-4 mt-2">
              Users
            </h1>
            <Button onClick={handleAddView} className="fs-15 fw-bold text-333">Add User</Button>
          </Col>
          
          <Col md={12} lg={12}>
            <Card className="border-0 mb-3">
              <DataTable userId={userId} />
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
